import { status } from '../../helpers'

const getProjectStoreDefaultState = () => {
  return {
    projectsListLoading: status.INITIALIZED,
    projectsList: [],
    loadingProjectDetails: status.INITIALIZED,
    loadingRecipients: status.INITIALIZED,
    loadingPublicProjectDetails: status.INITIALIZED,
    projectDetails: {},
    publicProjectDetails: {},
    totalCount: 0,
    projectRecipients: {},
    publicRecipients: {},
    recipientInfo: {
      name: '',
      email: '',
      phone: '',
      addressOne: '',
      addressTwo: '',
      city: '',
      country: 'US',
      state: '',
      zipcode: '',
      apparelSize: []
    },
    toggleAddressCollection: status.INITIALIZED,
    loadingProjectLinkInfo: status.INITIALIZED,
    projectInfo: {},
    settingProjectRecipientInfo: false,
    emailInUse: false,
    updatingAllowedDomains: false,
    updatingRecipientInfo: false,
    updatingPublicRecipientInfo: false,
    deletingRecipient: false,
    finalizingOrder: false,
    finalizingPublicOrder: false,
    searchingRecipient: false,
    verificationEmailSent: false,
    projectRecipientVerified: false
  }
}

export default getProjectStoreDefaultState
